// authService.js
import { Login, UpdatePasswordv2 } from "../api/Auth/auth";
// import rolesData from "./roles.json";
import CryptoJS from "crypto-js";
import {
  PRODUCT_VERSION,
  TOKEN_EXPIRY_TIME_IN_MINUTES,
} from "../helper/helper";
const SECRET_KEY = "1234pallaveceFSDwd";

export const login = async (username, password) => {
  const encypted_password = encryptPassword(password);
  const payload = {
    username,
    password: encypted_password,
  };
  const response = await Login(payload);
  console.log("********* response *****************");
  console.log(response);

  if (response) {
    const expiry = Date.now() + TOKEN_EXPIRY_TIME_IN_MINUTES * 60 * 1000;
    localStorage.setItem("user", JSON.stringify(response.user));
    localStorage.setItem("token", response.token);
    localStorage.setItem("tokenExpiry", expiry.toString());
    localStorage.setItem("appversion", PRODUCT_VERSION);
    return response;
  }
  return null;
};

export const updatePasswordv2 = async (username, oldpassword, newpassword) => {
  const encypted_password_old = encryptPassword(oldpassword);
  const encypted_password_new = encryptPassword(newpassword);
  const payload = {
    username,
    oldpassword: encypted_password_old,
    newpassword: encypted_password_new,
  };
  const response = await UpdatePasswordv2(payload);
  console.log("********* response *****************");
  console.log(response);

  return response;
};

export const getCurrentUser = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user;
};

// export const checkTokenExpiry = () => {
//   const expiry = localStorage.getItem("tokenExpiry");
//   if (expiry && Date.now() > parseInt(expiry, 10)) {
//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     localStorage.removeItem("tokenExpiry");
//   }
// };

export const checkTokenExpiry = () => {
  const expiry = localStorage.getItem("tokenExpiry");
  const app_version = localStorage.getItem("appversion");

  // Case 1: tokenExpiry is missing (old users who logged in before you added expiry logic)
  // Case 2: tokenExpiry exists but is past current time
  if (!app_version || !expiry || Date.now() > parseInt(expiry, 10)) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    localStorage.removeItem("app_version");
    return false; // ❌ Not valid, force login
  }

  return true; // ✅ Valid
};

export const getSubjectAssignments = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user) return false;

  const assignments = user?.assignments || undefined;

  if (!assignments) return false;

  return assignments;
};

export const isTeacher = () => {
  const user = getCurrentUser();
  if (!user) return false;

  const role = user.role;

  if (!role) return false;

  return role === "teacher";
};

export const isClassTeacher = (staff_id) => {
  console.log("isClassTeacher. Staff ID: ", staff_id);
  const assignments = getSubjectAssignments();

  if (assignments && assignments.length > 0) {
    const class_teacher_object = assignments.find(
      (record) =>
        record.teacher_id === staff_id &&
        record.class_teacher?.toLowerCase() === "yes"
    );
    if (
      class_teacher_object &&
      Object.entries(class_teacher_object).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getClassTeacherMap = (staff_id) => {
  console.log("isClassTeacher. Staff ID: ", staff_id);
  const assignments = getSubjectAssignments();

  console.log(assignments);

  if (assignments && assignments.length > 0) {
    const matchingAssignments = assignments.filter(
      (record) =>
        record.teacher_id === staff_id &&
        record.class_teacher?.toLowerCase() === "yes"
    );

    if (matchingAssignments.length > 0) {
      return matchingAssignments.reduce((acc, item) => {
        acc[`${item.class_id}-${item.section_id}`] = true;
        return acc;
      }, {});
    }
  }

  return {};
};

// export const getClassTeacherMap = (staff_id) => {
//   console.log("isClassTeacher. Staff ID: ", staff_id);
//   const assignments = getSubjectAssignments();

//   console.log(assignments);

//   if (assignments && assignments.length > 0) {
//     const class_teacher_object = assignments.find(
//       (record) =>
//         record.teacher_id === staff_id &&
//         record.class_teacher?.toLowerCase() === "yes"
//     );
//     if (
//       class_teacher_object &&
//       Object.entries(class_teacher_object).length > 0
//     ) {
//       return {
//         [`${class_teacher_object.class_id}-${class_teacher_object.section_id}`]: true,
//       };
//     } else {
//       return {};
//     }
//   } else {
//     return {};
//   }
// };

export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiry");
  localStorage.removeItem("appversion");
};

export const hasPermission = (permission) => {
  const user = getCurrentUser();
  if (!user) return false;

  const permissions = user.permissions;

  if (!permissions) return false;

  // const permissions = rolesData.permissions[user.role] || [];
  // console.log(
  //   "permissions.includes(permission): ",
  //   permissions.includes(permission)
  // );
  return permissions.includes(permission);
};

export const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
};

export const decryptPassword = (password) => {
  const bytes = CryptoJS.AES.decrypt(password, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
